import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import styled from 'styled-components';
import { priceFormatter } from '../../../helpers/formatters';
import Currency from '../Currency';
import CurrencyIcon from '../Icons/Currency';
import type { ITicketsController } from '../../../lib/widget/tickets/tickets.interface';
import { resolve } from 'inversify-react';
import { TicketsController } from '../../../lib/widget/tickets/tickets.controller';
import { TICKETS_MODULE_IDS } from '../../../lib/widget/tickets/tickets.types';

interface Props {
  data: {
    ticket_id: string;
    price: number;
    seller_name: string;
    selected: boolean;
    count?: number;
  };
  sector?: {
    id: string;
  };
  addTicket: (any) => void;
  removeTicket: (any) => void;
  selectTicket?: (sectorId: string, ticket: any) => void;
  t: (key: string, params?: any) => string;
}

interface State {
  selectedTickets: any;
}

class TicketItem extends Component<Props, State> {
  ticketsController: ITicketsController;

  @resolve(TicketsController) TicketsController;

  constructor(props, container) {
    super(props);

    this.ticketsController = container.get(TICKETS_MODULE_IDS.TICKETS_CONTROLLER);

    this.update = this.update.bind(this);
    this.handleClick = this.handleClick.bind(this);

    this.state = {
      selectedTickets: this.ticketsController.selectedTickets,
    };

    this.ticketsController.addListener(this.ticketsController.events.ADD, this.update);
    this.ticketsController.addListener(this.ticketsController.events.REMOVE, this.update);
  }

  get isSelected() {
    return this.state.selectedTickets.find(
      (ticket) => ticket.ticket_id === this.props.data.ticket_id,
    );
  }

  update() {
    this.setState({
      selectedTickets: this.ticketsController.selectedTickets,
    });
  }

  handleClick() {
    const { removeTicket, addTicket, selectTicket, data, sector } = this.props;

    if (selectTicket) return selectTicket(sector.id, data);

    if (this.isSelected) {
      removeTicket(data);
    } else {
      addTicket(data);
    }
  }

  render() {
    const { data } = this.props;

    return (
      <Item>
        <div>
          <Price>
            {data.count ? `${data.count} ${this.props.t('pcs')} - ` : null}{' '}
            <Currency>
              {priceFormatter(data.price)} <CurrencyIcon />
            </Currency>
          </Price>
          {data.seller_name}
        </div>
        <Button type="button" onClick={this.handleClick}>
          {this.isSelected ? this.props.t('remove') : this.props.t('select')}
        </Button>
      </Item>
    );
  }
}

// @ts-ignore
export default withTranslation()(TicketItem);

const Item = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  line-height: 18px;

  &:not(:last-child) {
    margin-bottom: 24px;
  }
`;

const Price = styled.div`
  margin-bottom: 1px;
  font-weight: bold;
  font-size: 16px;
  line-height: 21px;
`;

const Button = styled.button`
  padding: 5px 22px;
  margin-left: 16px;
  font-size: 16px;
  line-height: 21px;
  text-align: center;
  background: #ffda00;
  border-radius: 8px;
  border: 0;
  outline: none;

  &:hover,
  &:focus {
    background: #ffe54d;
  }
`;
